export default "__VITE_ASSET__3d5ee808__"